// Hallinans — real content scraped from hallinans.co.uk

export const FIRM = {
  name: "Hallinans",
  fullName: "Hallinan Blackburn Gittings & Nott",
  strapline: "Criminal Defence Lawyers London",
  accreditation: "Included in The Times Best Law Firm 2026",
  phone: "0207 828 8253",
  emergencyPhone: "07831 406 242",
  email: "solicitors@hallinans.co.uk",
  address: ["Alexandra House", "55A Catherine Place", "London", "SW1E 6DY"],
  hours: "9.30am – 5.30pm",
  socials: {
    instagram: "https://www.instagram.com/hallinanscriminaldefence/",
    facebook: "https://www.facebook.com/61554381287448",
    linkedin: "https://www.linkedin.com/in/namita-pawa-9150328b/",
  },
  heroImage:
    "https://images.unsplash.com/photo-1514557718210-26e452f8fab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsb25kb24lMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBza3lsaW5lfGVufDB8fHx8MTc4MTA3NTAzOXww&ixlib=rb-4.1.0&q=85",
  legalContextImage:
    "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzY2FsZXMlMjBvZiUyMGp1c3RpY2UlMjBsZWdhbHxlbnwwfHx8fDE3ODEwNzUwMzl8MA&ixlib=rb-4.1.0&q=85",
  officeImage:
    "https://images.unsplash.com/photo-1582653547187-2bb73b2d7b67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBsYXclMjBmaXJtJTIwb2ZmaWNlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxMDc1MDM5fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "criminal-defence",
    title: "Criminal Defence",
    icon: "Scale",
    featured: true,
    tagline:
      "Defence lawyers for all matters including drug charges, rape, sexual assault, controlling and coercive behaviour, murder, GBH and theft.",
    summary:
      "We are experts in criminal defence work representing those accused of every type of criminal matter. The depth and breadth of experience we have at the practice will ensure you have the highest quality representation from your first contact with us through to the conclusion of your matter.",
    covers: [
      "Murder & crimes of violence (e.g. GBH)",
      "Drug offences & large-scale conspiracies",
      "Sexual offences (e.g. rape & sexual assault)",
      "Controlling and coercive behaviour",
      "Theft and dishonesty offences",
    ],
    faqs: [
      {
        q: "I have been arrested — what should I do first?",
        a: "Say nothing until you have legal representation. You have the right to free, independent legal advice at the police station. Call our emergency line at any time on 07831 406 242 and we will attend or arrange representation immediately.",
      },
      {
        q: "Do you act for both legal aid and private clients?",
        a: "Yes. We defend both publicly and privately funded clients, and we maintain our own client contract with the Legal Aid Agency. Whatever your funding, you will receive the same exacting standard of representation.",
      },
      {
        q: "Which courts do you appear in?",
        a: "We conduct criminal litigation from the Magistrates' Court through to the Crown Court, the High Court, the Court of Appeal and as far as the Supreme Court.",
      },
    ],
  },
  {
    slug: "fraud",
    title: "Fraud & Money Laundering",
    icon: "Banknote",
    featured: true,
    tagline: "Criminal defence lawyers for fraud, money laundering and serious financial crime.",
    summary:
      "Having been a member of the Specialist Fraud Panel since its inception, we have the depth and breadth of experience to advise you on investigations into fraud and other types of financial crime. These cases are often complex and paper heavy and we break them down to aid in understanding and preparation for these allegations.",
    covers: [
      "Serious and complex fraud",
      "Money laundering",
      "Confiscation & restraint proceedings",
      "Investigations by the SFO, HMRC and FCA",
      "Cryptocurrency-related allegations",
    ],
    faqs: [
      {
        q: "I am under investigation but have not been charged. Should I get advice now?",
        a: "Yes — early advice is critical in fraud matters. How an interview under caution is handled can shape the entire case. We regularly secure outcomes where charges are never brought.",
      },
      {
        q: "These cases involve huge amounts of paperwork. How do you manage that?",
        a: "Fraud cases are often paper heavy. We break them down methodically so you understand exactly what is alleged, and we prepare a defence strategy built on complete command of the evidence.",
      },
      {
        q: "Are you recognised in this field?",
        a: "We have been a member of the Specialist Fraud Panel since its inception, and our work in serious fraud is recognised by the Legal 500 and Chambers and Partners.",
      },
    ],
  },
  {
    slug: "corporate-crime",
    title: "Corporate Crime",
    icon: "Building2",
    featured: true,
    tagline:
      "Defence lawyers for bribery, corruption, fraud, director's offences, phoenixing companies and more.",
    summary:
      "Offences committed relating to companies both by individuals and the corporate entity are becoming more common and the law an ever changing landscape. Our experience extends to representing both companies and their directors.",
    covers: [
      "Bribery & corruption",
      "Corporate fraud",
      "Directors' offences",
      "Phoenixing companies",
      "Regulatory investigations",
    ],
    faqs: [
      {
        q: "Can you act for the company as well as its directors?",
        a: "Yes. Our experience extends to representing both corporate entities and individual directors, and we will advise on conflicts at the outset.",
      },
      {
        q: "The company has received a request for information — what now?",
        a: "Do not respond before taking advice. The early stages of a corporate investigation often determine its outcome. We can manage the response and engage with investigators on your behalf.",
      },
    ],
  },
  {
    slug: "motoring-offences",
    title: "Road Traffic & Motoring Offences",
    icon: "Car",
    featured: false,
    tagline:
      "Defence lawyers for drink driving, speeding, driving without a licence or insurance, careless and dangerous driving, and death by dangerous driving.",
    summary:
      "Our solicitors have extensive experience in assisting clients who face prosecution for driving offences under the road traffic legislation, an area of law which is increasingly complex and far-reaching.",
    covers: [
      "Drink driving & drug driving",
      "Speeding & totting-up bans",
      "Driving without a licence or insurance",
      "Careless & dangerous driving",
      "Death by dangerous driving",
    ],
    faqs: [
      {
        q: "Will I lose my licence?",
        a: "Not necessarily. Penalties vary widely and there are often arguments to be made — from exceptional hardship to challenging the evidence itself. Early advice gives you the best prospect of keeping your licence.",
      },
      {
        q: "Is it worth instructing a solicitor for a motoring matter?",
        a: "Road traffic law is increasingly complex and far-reaching. A conviction can affect your livelihood, insurance and reputation. We assess every case for procedural and evidential weaknesses.",
      },
    ],
  },
  {
    slug: "extradition",
    title: "Extradition",
    icon: "Globe2",
    featured: false,
    tagline: "Criminal defence lawyers for individuals facing extradition.",
    summary:
      "Extradition is the official process whereby one country transfers an individual who is accused or convicted of a criminal offence to another country. This may be requested to enable the requesting country to try the individual on outstanding criminal charges or to ensure that they serve their sentence (if convicted).",
    covers: [
      "Extradition requests & arrest warrants",
      "Proceedings at Westminster Magistrates' Court",
      "High Court appeals",
      "Interpol Red Notice advice",
    ],
    faqs: [
      {
        q: "I have been arrested on an extradition warrant. What happens next?",
        a: "You will be brought before Westminster Magistrates' Court. Bars to extradition may apply — including human rights grounds, passage of time and forum. Contact us immediately so we can act before the initial hearing.",
      },
      {
        q: "Can extradition be challenged?",
        a: "Yes. Extradition is a highly technical area with numerous statutory bars and human rights protections. We will assess every available challenge from the outset.",
      },
    ],
  },
  {
    slug: "inquests-public-inquiries",
    title: "Inquests & Public Inquiries",
    icon: "Landmark",
    featured: false,
    tagline: "Lawyers for inquests, public inquiries and related proceedings.",
    summary:
      "These are fact-finding investigations into a set of events or deaths. They are specialist areas of the law in which we have a vast amount of experience. Preparation for such matters is crucial and we have the capability and experience to ensure that the vast quantity of evidence is analysed for the best representation for our clients.",
    covers: [
      "Representation of Core Participants in public inquiries",
      "Interested Persons at inquests",
      "Article 2 inquests",
      "Related criminal & regulatory proceedings",
    ],
    faqs: [
      {
        q: "What is the difference between an inquest and a public inquiry?",
        a: "An inquest is a fact-finding investigation into a death; a public inquiry investigates events of public concern. Neither determines criminal liability, but both can have serious consequences — careful preparation and representation is crucial.",
      },
      {
        q: "Have you acted in high-profile inquiries?",
        a: "Yes. Our experience includes representing a Core Participant in Phase 2 of the Grenfell Tower Inquiry and an Interested Party in the Stephen Port Inquest.",
      },
    ],
  },
  {
    slug: "trading-standards",
    title: "Trading Standards",
    icon: "ShieldCheck",
    featured: false,
    tagline: "Defence services for those charged with breaching trading standards regulations.",
    summary:
      "Investigations by Trading Standards for breaches of their Regulations can be a worrying time for a business. We are on hand to offer practical and robust advice and representation in responding to a request for information and interview.",
    covers: [
      "Responses to requests for information",
      "Interviews under caution",
      "Consumer protection prosecutions",
      "Product safety & labelling allegations",
    ],
    faqs: [
      {
        q: "Trading Standards have asked my business for information. Must I respond?",
        a: "Often yes — but how you respond matters enormously. We will advise on your obligations and manage the response to protect your position from the outset.",
      },
    ],
  },
  {
    slug: "regulatory",
    title: "Disciplinary & Regulatory",
    icon: "Gavel",
    featured: false,
    tagline: "Lawyers for individuals facing disciplinary and regulatory charges.",
    summary:
      "Our experience includes representing those in the police, healthcare professionals, lawyers and accountants. We are retained by the Police Federation to advise their members regarding disciplinary and regulatory matters as well as any follow on criminal proceedings.",
    covers: [
      "Police officers (retained by the Police Federation)",
      "Healthcare professionals",
      "Lawyers & accountants",
      "Follow-on criminal proceedings",
    ],
    faqs: [
      {
        q: "My professional body has opened an investigation. Could it become criminal?",
        a: "It can. We advise on both the disciplinary process and any follow-on criminal proceedings, ensuring nothing said in one forum prejudices the other.",
      },
    ],
  },
  {
    slug: "health-safety",
    title: "Health & Safety",
    icon: "HardHat",
    featured: false,
    tagline:
      "Defence lawyers for people accused of breaching health and safety rules and regulations.",
    summary:
      "It is a stressful time when a business is being investigated in relation to health and safety breaches, which can be regulatory or criminal brought by the Health and Safety Executive. The impact can be devastating both financially and reputationally.",
    covers: [
      "HSE investigations & prosecutions",
      "Workplace fatality investigations",
      "Corporate manslaughter allegations",
      "Improvement & prohibition notices",
    ],
    faqs: [
      {
        q: "The HSE is investigating an incident at our workplace. What should we do?",
        a: "Take advice before any interviews or written responses. The financial and reputational impact of an HSE prosecution can be devastating — early, robust representation protects your position.",
      },
    ],
  },
  {
    slug: "victims-of-crime",
    title: "Victims of Crime",
    icon: "HeartHandshake",
    featured: false,
    tagline: "Advice for individuals who may have been a victim of a crime.",
    summary:
      "As a victim of crime, you may find that you do not want to go to the police initially. We can assist with identifying the offences committed and helping you prepare a witness statement for submission to the police and guiding you through the process.",
    covers: [
      "Identifying offences committed against you",
      "Preparing witness statements",
      "Guidance through the police process",
      "Discreet, empathetic advice",
    ],
    faqs: [
      {
        q: "I'm not sure I want to go to the police yet. Can you still help?",
        a: "Yes. Many clients come to us before approaching the police. We help you understand the offences committed, prepare a witness statement, and guide you through the process at your pace.",
      },
    ],
  },
  {
    slug: "general-advisory",
    title: "General Legal Advice",
    icon: "MessagesSquare",
    featured: false,
    tagline: "A full range of defence legal services, including motoring and theft.",
    summary:
      "We are often approached by clients who want general advice. This may be in relation to a criminal investigation of which they are the subject or in fact how to protect their own position if someone close to them is the subject of an investigation or prosecution.",
    covers: [
      "Advice for those under investigation",
      "Protecting your position when someone close to you is investigated",
      "Pre-charge engagement",
      "Discreet second opinions",
    ],
    faqs: [
      {
        q: "Someone close to me is being investigated. Can I get advice for myself?",
        a: "Yes — and you should. We frequently advise individuals on how to protect their own position when a family member, colleague or business partner is the subject of an investigation or prosecution.",
      },
    ],
  },
];

export const TEAM = [
  {
    slug: "namita-pawa",
    name: "Namita Pawa",
    role: "Managing Director & Solicitor",
    email: "np@hallinans.co.uk",
    phone: "0207 828 8253",
    linkedin: "https://www.linkedin.com/in/namita-pawa-9150328b/",
    image:
      "https://static.wixstatic.com/media/a11288_5698c4669dd64fc3a05fbdad23f30f4e~mv2.png/v1/crop/x_0,y_224,w_1496,h_1157/fill/w_580,h_448,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202023-08-30%20at%2009_51_22.png",
    short:
      "Never leaving a stone unturned, Namita specialises in representing those facing allegations of murder, drug offences and serious fraud.",
    bio: [
      "With over twenty years' experience, Namita Pawa is a highly respected Solicitor and Managing Director at Hallinans.",
      "Namita's tenacity and determination have provided the bedrock for a vast number of cases covering the full spectrum of criminal law, including murder, serious fraud, large-scale drug conspiracies, sexual offences, and driving matters.",
      "Namita joined Hallinans in 2013 and quickly became a key figure in the firm. She was appointed equity partner in 2016 and became Managing Director in 2022.",
      "As Hallinans' Managing Director, she leads from the front, developing and growing the team, modernising the firm's infrastructure by taking it paperless, and building on Hallinans' decades long reputation for excellence.",
      "She has also cultivated a strong ethos of mentorship and inclusion, establishing a partnership with Bridging the Bar to offer internships at the firm to aspiring barristers from underrepresented backgrounds.",
      "Namita primarily advises on private client matters but remains deeply committed to publicly funded work, ensuring the firm maintains its own client contract with the Legal Aid Agency. She is widely recognised as the Solicitor of choice for referrals from other law firms and is frequently trusted to represent fellow professionals and their families.",
      "Since 2009, Namita has been the legal consultant to multiple TV programmes on the BBC, ITV, Sky, Netflix and Amazon, including: Law and Order: UK, Broadchurch, Unforgotten, Cold Feet, Undercover, Call the Midwife and Apple Tree Yard.",
    ],
    quotes: [
      {
        source: "Legal 500",
        text: "Namita Pawa is a tour de force. She has incredible insight into a case and brilliant client handling skills.",
      },
      {
        source: "Chambers and Partners",
        text: "Namita is absolutely brilliant. She is willing to really go out for her clients and goes the extra mile for them. She is down to earth, realistic and really approachable.",
      },
      {
        source: "Recent Client",
        text: "It was a relief to meet Namita. A force of nature. Kind. Confident. A presence with gravitas.",
      },
    ],
    awards: [
      "Partner of Top Ranked Firm Hallinans in Times Best Law Firms 2026",
      "Top Ranked Chambers and Partners Lawyer 2026",
      "Partner of Top Ranked Firm Hallinans in Chambers and Partners 2026",
      "Partner of Top Ranked Firm Hallinans in Legal 500 2026",
      "Nominated Criminal Lawyer of the Year 2016 (Society of Asian Lawyers)",
      "Nominated 'In the Spotlight' April 2022 (Member of the Female Fraud Forum)",
    ],
    memberships: [
      "London Criminal Courts' and Solicitors Association",
      "Women in Criminal Law (Committee member)",
      "Fraud Lawyer's Association",
      "Society of Asian Lawyers",
      "Female Fraud Forum",
    ],
    cases: [
      {
        title: "R v O",
        text: "Individual charged with evading the UK's Russia sanctions regime. The first prosecution under the Russia Regulations — our client was acquitted following a 4-week trial at Southwark Crown Court.",
      },
      {
        title: "Grenfell Tower Inquiry",
        text: "Representing a Core Participant in Phase 2.",
      },
      {
        title: "R v W",
        text: "Acquittal of individual charged with bribery and money laundering following trial at Southwark Crown Court relating to the office fit out industry.",
      },
      {
        title: "Stephen Port Inquest",
        text: "Representing an Interested Party following the rape and murder of four young men in East London.",
      },
      {
        title: "R v H",
        text: "Four handed murder trial at the Central Criminal Court where zombie knives were purchased on Snapchat.",
      },
      {
        title: "EncroChat",
        text: "Represented multiple individuals charged with wide scale cocaine supply.",
      },
      {
        title: "R v K",
        text: "Cryptocurrency, DarkWeb and fake Xanax tablets. The subject of the case at Portsmouth Crown Court.",
      },
      {
        title: "R v A",
        text: "Acquittal of individual charged with rape following trial at Inner London Crown Court.",
      },
    ],
  },
  {
    slug: "ben-baker",
    name: "Ben Baker",
    role: "Solicitor",
    email: "solicitors@hallinans.co.uk",
    phone: "0207 828 8253",
    image:
      "https://static.wixstatic.com/media/ef24a1_d8a3b32faab94d9eb9d95ef1f69602b2~mv2.png/v1/fill/w_580,h_510,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Ben.png",
    short:
      "Ben acts across the full spectrum of criminal defence work, from the police station through to the Crown Court.",
    bio: [
      "Ben is a Solicitor at Hallinans, acting for clients across the full spectrum of criminal defence work — from first attendance at the police station through to trial in the Crown Court.",
      "He is committed to clear communication and meticulous preparation, ensuring every client understands the process and feels supported at each stage of their case.",
    ],
  },
  {
    slug: "louise-scott",
    name: "Louise Scott",
    role: "Consultant",
    email: "solicitors@hallinans.co.uk",
    phone: "0207 828 8253",
    image:
      "https://static.wixstatic.com/media/9a6e79_5e9bf6a7e81c4569bd1d0564d162ccf1~mv2.jpg/v1/fill/w_580,h_510,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Louise%20Scott_edited.jpg",
    short:
      "Louise brings decades of experience in criminal litigation as a Consultant to the firm.",
    bio: [
      "Louise is a Consultant at Hallinans, bringing decades of experience in criminal litigation to the firm's most serious and complex cases.",
      "Her depth of knowledge across criminal law makes her a trusted adviser to clients and colleagues alike.",
    ],
  },
  {
    slug: "connor-byrne",
    name: "Connor Byrne",
    role: "Paralegal",
    email: "solicitors@hallinans.co.uk",
    phone: "0207 828 8253",
    image:
      "https://static.wixstatic.com/media/ef24a1_72df9d36a48d46359c3baf2cb12e4069~mv2.png/v1/crop/x_0,y_88,w_2258,h_1985/fill/w_580,h_510,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Connor.png",
    short:
      "Connor supports the team across serious crime and fraud cases, assisting with case preparation and client care.",
    bio: [
      "Connor is a Paralegal at Hallinans, supporting the team across serious crime and fraud cases.",
      "He assists with case preparation, evidence analysis and client care, playing a key role in the firm's meticulous approach to every matter.",
    ],
  },
  {
    slug: "niamh-dennis",
    name: "Niamh Dennis",
    role: "Paralegal",
    email: "solicitors@hallinans.co.uk",
    phone: "0207 828 8253",
    image:
      "https://static.wixstatic.com/media/ef24a1_cadcad58bf094fe4ba47664def29fbb8~mv2.png/v1/crop/x_0,y_88,w_2258,h_1985/fill/w_580,h_510,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Niamh%20Hallinans.png",
    short:
      "Niamh supports the firm's caseload with diligent preparation and a strong commitment to client care.",
    bio: [
      "Niamh is a Paralegal at Hallinans, supporting the firm's caseload with diligent preparation and a strong commitment to client care.",
      "She works closely with the firm's solicitors on cases ranging from motoring offences to serious crime.",
    ],
  },
];

export const TESTIMONIALS = [
  {
    source: "Legal 500",
    text: "The team at Hallinans has a highly deserved reputation as dedicated to achieving the best result in serious and complex criminal litigation.",
  },
  {
    source: "Chambers and Partners",
    text: "Hallinans punch very much above its weight. They are in some of the most serious criminal cases and have a stellar reputation.",
  },
  {
    source: "Recent Client",
    text: "A world class legal firm who leave no stone unturned.",
  },
];

export const TIMELINE = [
  {
    period: "1950s",
    title: "The firm is founded",
    text: "Hallinans begins practising in London, establishing the foundations of a firm that would become synonymous with serious criminal defence.",
  },
  {
    period: "Decades of growth",
    title: "A reputation built on results",
    text: "As Hallinan Blackburn Gittings & Nott, the firm becomes a fixture in the most serious and complex criminal cases — from the Magistrates' Court to the Supreme Court.",
  },
  {
    period: "2013",
    title: "Namita Pawa joins the firm",
    text: "Namita quickly becomes a key figure, appointed equity partner in 2016 and Managing Director in 2022, modernising the firm and taking it paperless.",
  },
  {
    period: "Today",
    title: "The Times Best Law Firm 2026",
    text: "Recognised by The Times, the Legal 500 and Chambers and Partners, Hallinans remains a market leader for expertise, bespoke approach and client care.",
  },
];
